<template>
  <div>
    <div class="course-list">
      <template v-for="(course, courseIndex) in auditionList">
        <div class="course" :key="courseIndex">
          <!-- 课程名字 -->
          <p class="course-name" @click="toggleStageList(courseIndex)">
            <span v-text="course.courseName"></span>
            <van-icon name="arrow-down"></van-icon>
          </p>

          <!-- 阶段列表 -->
          <div v-show="courseIndex === courseId" class="stage-list">
            <div
              class="stage"
              v-for="(stage, stageIndex) in course.stageList"
              :key="stageIndex"
            >
              <!-- 阶段名字 -->
              <p class="stage-name" @click="toggleVideoList(stageIndex)">
                <van-icon name="tv-o"></van-icon>
                <span>
                  {{ stage.stageName }}
                  <span v-if="stage.videoList.length > 0" class="shiting">
                    (可试听)
                  </span>
                </span>
                <van-icon name="plus"></van-icon>
              </p>

              <!-- 视频列表 -->
              <ul v-show="stageIndex === stageId" class="video-list">
                <li v-if="stage.videoList.length === 0" class="video">
                  <span>详情见正式班课程</span>
                </li>
                <template v-else>
                  <li
                    class="video"
                    v-for="(video, videoIndex) in stage.videoList"
                    :key="videoIndex"
                    @click="play(video.url)"
                  >
                    <van-icon name="play-circle-o"></van-icon>
                    <span v-text="video.videoName"></span>
                    <van-button v-if="video.url" type="primary" plain>
                      点击试听
                    </van-button>
                  </li>
                  <li class="video"><span>...</span></li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- 播放器 -->
    <van-popup v-model="playing">
      <div :key="playUrl" class="player">
        <video controls autoplay name="media">
          <source :src="playUrl" type="video/mp4" />
        </video>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'DetailCatalog',
    data() {
      return {
        auditionList: [],
        courseId: '', // 当前展开的课程
        stageId: '', // 当前展开的阶段
        playing: false,
        playUrl: null, // 播放地址
      };
    },
    created() {
      this.showLoading();
      this.getVideos(this.$route.params.listenIndexId).then(
        ({ data: { code, data } }) => {
          if (code === 200) {
            this.hideLoading();
            this.auditionList = data;
          }
        },
      );
    },
    methods: {
      getVideos(id) {
        return axios.get(
          `https://api.zhuokao360.com/listen/findListenVideo?listenIndexId=${id}`,
        );
      },

      // 播放视频
      play(url) {
        if (!url) {
          return;
        }
        this.playing = true;
        this.playUrl = url;
      },

      // 展开收缩课程阶段列表
      toggleStageList(courseId) {
        this.courseId = this.courseId === courseId ? '' : courseId;
        this.stageId = '';
      },

      // 展开收缩阶段视频列表
      toggleVideoList(stageId) {
        this.stageId = this.stageId === stageId ? '' : stageId;
      },
    },
  };
</script>

<style lang="scss" scoped>
/* 试听 */
.course-list,
.stage-list,
.video-list {
  display: flex;
  flex-direction: column;
}

.course {
  padding: 0 20px;
  background-color: #fff;
}

.course-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  font-size: 16px;
  color: #333;
}

.stage {
  padding-left: 10px;
  border-bottom: 1px solid #eee;
}

.stage-name {
  display: flex;
  align-items: center;
  height: 48px;
  font-size: 14px;
  color: #666;
}

.stage-name > span {
  flex: 1;
  margin: 0 20px 0 10px;
}

.shiting {
  margin-left: 5px;
  color: #e13b29;
}

.video {
  display: flex;
  align-items: center;
  padding-left: 10px;
  height: 36px;
  font-size: 12px;
  color: #999;
}

.video > span {
  flex: 1;
  margin: 0 20px 0 10px;
}

.video .van-button {
  height: 20px;
  padding: 0 4px;
  font-size: 10px;
}

.player {
  position: relative;
  width: 96vw;
  max-width: 600px;
  padding-bottom: 56.25%;
  background-color: #fff;
}

.player video {
  position: absolute;
  left: 0;
  top: 0;
  margin: 4px;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
}
</style>
